import { UsersOrderByEnum } from '@/api/user/user.api';
import StandaloneLoader from '@/components/@next/StandaloneLoader';
import { UserShowcaseSearchDto } from '@/types';
import { scrollToTop } from '@/utils/scrollToTop';
import React, { CSSProperties } from 'react';
import SelectOrderBy from './SelectOrderBy';
import UserItem from './UserItem';

const gridStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(288px, 1fr))',
  gap: '28px',
};

const TopShowcases = ({
  orderBy,
  setOrderBy,
  showcases,
  isLoading,
  setSelectedShowcase,
}: {
  orderBy: UsersOrderByEnum;
  setOrderBy: React.Dispatch<React.SetStateAction<UsersOrderByEnum>>;
  showcases: UserShowcaseSearchDto[] | undefined;
  isLoading: boolean;
  setSelectedShowcase: (user: UserShowcaseSearchDto) => void;
}) => {
  return (
    <div className="max-h-[450px] xl:max-h-fit xl:h-rest px-4 md:px-9 py-7 lg:py-12 flex flex-col bg-amber-f8">
      <h1 className="text-base xs:text-lg md:text-2xl font-extrabold flex items-center">
        Top Showcases by
        <SelectOrderBy orderBy={orderBy} setOrderBy={setOrderBy} />
      </h1>

      <div style={gridStyle} className="mt-7 md:mt-10 overflow-auto">
        {isLoading && (
          <div className="w-full h-full flex items-center justify-center">
            <StandaloneLoader />
          </div>
        )}

        {showcases?.map((user, index) => (
          <UserItem
            key={user.id}
            user={user}
            index={index}
            onClick={() => {
              setSelectedShowcase(user);
              scrollToTop({ behavior: 'smooth' });
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default TopShowcases;
